import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import config from "../../config/config";
import Loader from '../loader/Loader';
export default function GenerateReport({ show, handleClose }) {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productId, setProductId] = useState(null);
  const [productOptions, setProductOptions] = useState([]);
  const [productLoading, setProductLoading] = useState(false);
  useEffect(() => {
    if (show) {
      fetchProductList();
      fetchReport()
    }
  }, [show]);

  const fetchProductList = async () => {
    const token = getAuthToken();
    if (!token) return;

    setProductLoading(true);
    try {
      const response = await axios.get(`${config.API}/product/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const formattedProducts =
        response?.data?.products?.map((plist) => ({
          value: plist.id,
          label: plist.name,
        })) || [];

      setProductOptions(formattedProducts);

    } catch (err) {
      console.error("Error fetching products:", err);
    } finally {
      setProductLoading(false);
    }
  };
  const fetchReport = async () => {
    const token = getAuthToken();
    if (!token) return;
    setLoading(true);
    try {
      const response = await axios.post(
        `${config.API}/supervisor/supervisorproductionreport`,
        {
          start_date: fromDate,
          end_date: toDate,
          product_id: productId
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response?.data?.success) {
        setReportData(response?.data?.report || []);
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
      setReportData([]);
    } finally {
      setLoading(false);
    }
  };


  const downloadPDF = () => {
    if (!reportData.length) return;
    const doc = new jsPDF();
    const selectedProduct = productOptions.find(
      (p) => p.value === productId
    );
    const productName = selectedProduct ? selectedProduct.label : "";
    doc.text(`${productName}`, 14, 15);
    const tableRows = reportData.map(item => ([
      item.date,
      item.production_date??"No Data",
      item.opening_stock,
      item.stock_in,
      item.dispatched_stock,
      item.rejected_stock,
      item.closing_stock
    ]));

    autoTable(doc, {
      startY: 20,
      head: [[
        "Date",
        "Production Date",
        "Opening",
        "Produced",
        "Dispatched",
        "Rejected",
        "Closing"
      ]],
      body: tableRows,
    });

    doc.save("Production_Report.pdf");
  };

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered className='font_family '>
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold">Daily Rubber Product Stock</Modal.Title>
      </Modal.Header>
      {
        loading ? (
          <Loader />
        ) : (
          <Modal.Body>
            <Row className="align-items-end mb-3">
              {/* ✅ Product Dropdown */}
              <Col md={3}>
                <Form.Label>Select Product</Form.Label>
                <Select
                  options={productOptions}
                  placeholder="Select Product"
                  isClearable
                  isLoading={productLoading}
                  value={productOptions.find(p => p.value === productId) || null}
                  onChange={(selected) => {
                    setProductId(selected ? selected.value : null);
                  }}
                />
              </Col>

              <Col md={2}>
                <Form.Label>From Date</Form.Label>
                <Form.Control
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </Col>

              <Col md={2}>
                <Form.Label>To Date</Form.Label>
                <Form.Control
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </Col>

              <Col md={2}>
                <Button
                  variant="primary"
                  onClick={fetchReport}
                  className="w-100"
                  disabled={!productId || !fromDate || !toDate}
                >
                  Apply
                </Button>
              </Col>

              <Col md={2}>
                <Button
                  variant="success"
                  onClick={downloadPDF}
                  className="w-100"
                  disabled={!reportData.length}
                >
                  Download PDF
                </Button>
              </Col>

              <Col md={1}>
                <Button
                  variant="secondary"
                  onClick={() => {
                    setFromDate('');
                    setToDate('');
                    setProductId(null);
                    setReportData([]);
                  }}
                  className="w-100"
                >
                  Clear
                </Button>
              </Col>
            </Row>

            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Production Date</th>
                  <th>Opening</th>
                  <th>Produced</th>
                  <th>Dispatched</th>
                  <th>Rejected</th>
                  <th>Closing</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" className="text-center">Loading...</td>
                  </tr>
                ) : reportData.length > 0 ? (
                  reportData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.date}</td>
                      <td>{item.production_date??"No Data"}</td>
                      <td>{item.opening_stock}</td>
                      <td>{item.stock_in}</td>
                      <td>{item.dispatched_stock}</td>
                      <td>{item.rejected_stock}</td>
                      <td>{item.closing_stock}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

          </Modal.Body>
        )
      }
    </Modal>
  );
}